<template>
  <div>
    <div class="row">
      <div class="col">
        <h5>
          Dear Parents,<br />
          The application form will take approximately 10-20 minutes to complete. You will need to upload the following documents as part of your application.
          Please prepare them in advance to shorten the time needed to complete the application process.
        </h5>
      </div>
    </div>

    <div class="row">
      <h5 class="col"><b>Documents checklist</b></h5>
    </div>

    <div v-if="selected === schools['Broadrick']">
      <ol>
        <li>Copy of each parent's passport</li>
        <li>Copy of each parent's IC (for Singaporean / Permanent Resident) or FIN card (copied on both sides)</li>
        <li>Copy of student's passport</li>
        <li>Copy of student's birth certificate (Singaporean only) or Re-Entry Permit (Permanent Resident only) or FIN card (copied on both sides)</li>
        <li>Copy of student's latest school report (in English).</li>
        <li>
          Copy of student's most up to date immunisation record (*Note: immunisation against Diphtheria and Measles is compulsory in Singapore.Immunisation
          records are required for students under 12 years old)
        </li>
        <li>Digital photographs of student and each parent (photo must be clear, front-facing and taken against white background)</li>
        <li>Copy of all relevant medical, psychoeducation, developmental or special education evaluation reports (if applicable)</li>
        <li>
          Screenshot or proof of payment for the application fee of $654. (Payment methods can be found on the
          <a target="_blank" href="https://www.etonhouse.edu.sg/school/broadrick/fees/">school fees page</a>)
        </li>
      </ol>
      <br />
      <h5><b>Other Documents required</b></h5>
      <ul>
        <li>
          a) Student Reference Form. (This form is to be completed and sent directly back to us by your child's current/previous school).
          <a href="https://kws.etonhouse.com/images/Broadrick_Student_Reference_Form.pdf" target="_blank">Download here</a>
        </li>
      </ul>
    </div>

    <div v-if="selected === ehSchoolsData?.Claymore?.schoolID">
      <ol>
        <li>Copy of child's vaccination record</li>
        <li>Copy of 1 passport-sized photograph of your child</li>
        <li>Copy of child's Dependant Pass/ Student Pass (if applicable)</li>
        <li>Any other relevant medical reports (if applicable)</li>
        <li>Screenshot or proof of payment* of the registration fee of $2,834.</li>
      </ol>
    </div>

    <div v-if="selected === schools['Orchard']">
      <ol>
        <li>Copy of each parent's passport</li>
        <li>Copy of each parent's IC (for Singaporean / Permanent Resident) or FIN card (copied on both sides)</li>
        <li>Copy of student's passport</li>
        <li>Copy of student's birth certificate (Singaporean only) or Re-Entry Permit (Permanent Resident only) or FIN card (copied on both sides)</li>
        <li>Student's Previous 2 Years of School Reports</li>
        <ol>
          <li style="padding-left: 20px; list-style: lower-alpha">Last year level full year school report</li>
          <li style="padding-left: 20px; list-style: lower-alpha">
            Current year level full year school report (or all reports you have received for current year)
          </li>
        </ol>
        <li>
          Copy of student's most up to date immunisation record (*Note: immunisation against Diphtheria and Measles is compulsory in Singapore. Immunisation
          records are required for students under 12 years old)
        </li>
        <li>Digital photographs of student and each parent (photo must be clear, front-facing and taken against white background)</li>
        <li>Copy of all relevant medical, psychoeducation, developmental or special education evaluation reports (if applicable)</li>
        <li>
          Screenshot or proof of payment for the application fee of $654. (Payment methods can be found on the
          <a target="_blank" href="https://www.etonhouse.edu.sg/school/orchard/fees/">school fees page</a>)
        </li>
      </ol>
      <br />
      <h5><b>Other Documents required</b></h5>
      <ul>
        <li>
          Student Reference Form (This form is to be completed and sent directly back to us by your child's current/previous school).
          <a href="https://kws.etonhouse.com/images/EH%20Orchard%20Student%20Reference%20Form.pdf" target="_blank">Download here</a>
        </li>
      </ul>
    </div>

    <div v-if="selected === schools['Sentosa Primary']">
      <ol>
        <li>Copy of each parent's passport</li>
        <li>Copy of each parent's IC (for Singaporean / Permanent Resident) or FIN card (copied on both sides)</li>
        <li>Copy of student's passport</li>
        <li>Copy of student's birth certificate (Singaporean only) or Re-Entry Permit (Permanent Resident only) or FIN card (copied on both sides)</li>
        <li>Copy of student's latest school report (in English)</li>
        <li>Copy of student's most up to date immunisation record (*Note: immunisation against Diphtheria and Measles is compulsory in Singapore)</li>
        <li>Digital photographs of student and each parent (photo must be clear, front-facing and taken against white background)</li>
        <li>Copy of all relevant medical, psychoeducation, developmental or special education evaluation reports (if applicable)</li>
        <li>
          Screenshot or proof of payment for the application fee of $654. (Payment methods can be found on the
          <a target="_blank" href="https://www.etonhouse.edu.sg/school/sentosa/fees/">school fees page</a>)
        </li>
      </ol>
      <br />
      <h5><b>Other Documents required</b></h5>
      <ul>
        <li>
          a) Student Reference Form (This form is to be completed and sent directly back to us by your child's current/previous school).
          <a href="https://www.etonhouse.edu.sg/wp-content/uploads/2021/01/Student-Reference-Form_EHIS-2017-New-URL.pdf" target="_blank">Download here</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { ehSchoolsData } from '@/pages/application/data'

export default {
  name: 'ApfEhSupportingDocument',
  props: ['selected', 'schools'],
  data() {
    return {
      ehSchoolsData,
      selectedPreSchools: {},
    }
  },
}
</script>
